import React, { useState } from 'react';
import { motion } from 'framer-motion';
import DemoSession from '../components/DemoSession';

const Demo: React.FC = () => {
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (formData: any) => {
    console.log('Demo handleSubmit called with:', formData);
    setIsSubmitting(true); // Show loading state immediately
    
    try {
      const scriptURL = 'https://script.google.com/macros/s/AKfycbwJ-BN3TJeu2kKRrk43WNYK4Bt2vgT6kNPBqf3ZP5vcXFMQDA1KEf1op0vqybT6OaMO/exec';
      
      // Prepare parameters for URL
      const params = [
        `parentName=${encodeURIComponent(formData.parentName)}`,
        `childName=${encodeURIComponent(formData.childName)}`,
        `email=${encodeURIComponent(formData.email)}`,
        `phone=${encodeURIComponent(formData.phone)}`,
        `preferredTrack=${encodeURIComponent(formData.preferredTrack)}`,
        `preferredTime=${encodeURIComponent(formData.preferredTime)}`,
        `message=${encodeURIComponent(formData.message || '')}`,
        `timestamp=${encodeURIComponent(new Date().toISOString())}`,
        `type=demo`,
        `nocache=${new Date().getTime()}`
      ].join('&');
      
      // Create image ping
      const img = new Image();
      img.style.display = 'none';
      img.onload = () => {
        setIsSubmitting(false);
        setSubmitted(true);
      };
      img.onerror = () => {
        setIsSubmitting(false);
        setSubmitted(true);
      };
      img.src = `${scriptURL}?${params}`;
      document.body.appendChild(img);
      
      // Remove after a short delay
      setTimeout(() => {
        if (document.body.contains(img)) document.body.removeChild(img);
      }, 3000);
      
      // Fallback: if no response after 5 seconds, show success anyway
      setTimeout(() => {
        if (isSubmitting) {
          setIsSubmitting(false);
          setSubmitted(true);
        }
      }, 5000);
      
    } catch (error) {
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
      setSubmitted(true);
    }
  };

  // Add loading state display
  if (isSubmitting) {
    return (
      <div className="demo-page">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="loading-message"
            style={{
              textAlign: 'center',
              padding: '4rem 2rem',
              maxWidth: '800px',
              margin: '0 auto',
              backgroundColor: '#f8f9ff',
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
            }}
          >
            <div style={{
              fontSize: '3rem',
              color: '#4f46e5',
              marginBottom: '1.5rem',
              animation: 'spin 1s linear infinite'
            }}>
              ⏳
            </div>
            <h2 style={{
              fontSize: '2rem',
              color: '#1a1f35',
              marginBottom: '1rem'
            }}>
              Submitting Your Demo Request...
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#4a5568',
              lineHeight: '1.6'
            }}>
              Please wait while we process your demo session request.
            </p>
          </motion.div>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="demo-page">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="success-message"
            style={{
              textAlign: 'center',
              padding: '4rem 2rem',
              maxWidth: '800px',
              margin: '0 auto',
              backgroundColor: '#f8f9ff',
              borderRadius: '16px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)'
            }}
          >
            <div style={{
              fontSize: '4rem',
              color: '#4f46e5',
              marginBottom: '1.5rem'
            }}>
              ✓
            </div>
            <h2 style={{
              fontSize: '2.2rem',
              color: '#1a1f35',
              marginBottom: '1rem'
            }}>
              Demo Session Request Submitted!
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#4a5568',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              Thank you for your interest in IIITD-IC Summer Camp 2026. We'll contact you within 24 hours to confirm your demo session.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                backgroundColor: '#4f46e5',
                color: 'white',
                border: 'none',
                padding: '0.8rem 2rem',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#4338ca';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#4f46e5';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              Back to Home
            </button>
          </motion.div>
        </div>
      </div>
    );
  }

  return <DemoSession onSubmit={handleSubmit} />;
};

export default Demo;
